import { t } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";
import { useMutation } from "@tanstack/react-query";

import { patchControlsBulkReassign } from "api/generated/controls/controls";
import {
    ControlBulkReassignmentParams,
    ExistingAssignmentsPolicy,
    ControlReassignment,
} from "api/generated/model";

import { BulkAssignStep } from "../stepsContainer";

export const BULK_ASSIGN_MUTATION_KEY = "bulkAssign";

interface BulkAssignMutationVars {
    policy: ExistingAssignmentsPolicy;
    controlReassignments: Record<string, ControlReassignment[]>;
    onSuccess?: (step: BulkAssignStep) => void;
}

export function useSubmitBulkAssignMutation() {
    return useMutation({
        mutationKey: [BULK_ASSIGN_MUTATION_KEY],
        mutationFn: async ({
            policy,
            controlReassignments,
        }: BulkAssignMutationVars) => {
            const payload: ControlBulkReassignmentParams = {
                existingAssignmentsPolicy: policy,
                controlReassignments,
            };

            return patchControlsBulkReassign(payload);
        },
        onSuccess: (_data, variables) => {
            emitNotification("success", t("ControlsBulkAssign_Success"));
            variables.onSuccess?.("export");
        },
        onError: () => {
            emitNotification("error", t("ControlsBulkAssign_Error"));
        },
    });
}
